<script setup>
import { RouterView, useRoute } from 'vue-router'
import { computed } from 'vue'
import AppNav from './components/AppNav.vue'

const route = useRoute()
const showNav = computed(() => route.name !== 'login')
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <AppNav v-if="showNav" />
    <main class="flex-1">
      <RouterView />
    </main>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
